// extracted by mini-css-extract-plugin
export default {"mapbox":"QueryPage_mapbox__fNaJr","maxwidth":"QueryPage_maxwidth__SoX94","posttype":"QueryPage_posttype__VzrAJ","flex":"QueryPage_flex__br-D5","des":"QueryPage_des__-mmdQ"};